<template>
  <div class="d-flex flex-column align-center pt-12">
    
    <!-- <v-btn
      tile
      width="200"
      height="40"
      depressed
      color="primary"
      class="buttonText mt-2"
      @click="$router.push('/frontDesk/touristTest/first')"
    >{{$t('frontMenu.touristTest')}}</v-btn>
    -->
    <v-btn
      tile
      width="200"
      height="40"
      depressed
      color="primary"
      class="buttonText mt-2"
      @click="$router.push('/selfService/cellexTest/first')"
    >{{$t('frontMenu.cellexTest')}}</v-btn> 
    <!-- <v-btn
      tile
      width="200"
      height="40"
      depressed
      color="primary"
      v-else
      class="buttonText mt-12"
      @click="$router.push('/frontDesk/shippingTest/first')"
    >{{$t('frontMenu.shippingTest')}}</v-btn>
    <v-btn
      tile
      width="200"
      height="40"
      depressed
      color="primary"
      class="buttonText mt-2"
      @click="$router.push('search')"
    >{{$t('frontMenu.search')}}</v-btn> -->
    <!-- <v-btn
      tile
      width="200"
      height="40"
      depressed
      color="primary"
      class="buttonText mt-2"
    >{{$t('frontMenu.export')}}</v-btn> -->

    <div class="d-flex mt-auto">

   

    <div class="d-flex flex-column align-center dn2me-logo mt-5">
      <div class="subtitle-1 font-weight-bold mb-2 caption">Powered by:</div>
      <img src="@/assets/authHeader.png" style="width:200px; height:100px"/>
    </div>
     <div class="d-flex flex-column align-center mt-auto ml-2">
      <div class="subtitle-1 font-weight-bold mb-2 caption">With the support of:</div>
      <div class="d-flex logos">
        <!-- <a href="https://cellex.gr/" target="_blank">
          <img src="@/assets/cellex.png" />
        </a> -->
        <img src="@/assets/brainz.png" style="width:100px;"/>
      </div>
    </div>
    </div>

  </div>
</template>

<script>
export default {
  // created(){
  //   this.$store.dispatch('setLocale')
  // },
  // methods: {
  //   isBio(){
  //     if(sessionStorage.getItem('userName') == 'bioiatrikiFront') return true
  //     return false
  //   }
  // }
};
</script>